import { barrageItems, hotTopics } from "@/mocks/guaData";

export default function Hero() {
  return (
    <section
      id="top"
      className="relative overflow-hidden bg-gradient-to-b from-primary-100 via-background-50 to-background-50 pb-16 pt-28 md:pt-32"
    >
      {/* 装饰 */}
      <div className="pointer-events-none absolute -left-16 top-24 h-52 w-52 rounded-full bg-accent-200/70 blur-2xl"></div>
      <div className="pointer-events-none absolute -right-10 top-40 h-60 w-60 rounded-full bg-secondary-300/60 blur-2xl"></div>

      <div className="container-page relative">
        <div className="mx-auto max-w-3xl text-center">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-4 py-1.5 text-sm font-bold text-accent-800">
            <i className="ri-fire-line"></i>
            今日热瓜实时更新中
          </span>

          <h1 className="heading-font mt-6 text-4xl leading-snug text-foreground-950 md:text-6xl md:leading-snug">
            明星吃瓜现场
            <br />
            <span className="text-primary-500">爆笑热评一网打尽</span>
          </h1>

          <p className="mx-auto mt-6 max-w-2xl text-base leading-7 text-foreground-600 md:text-lg">
            热评弹幕、表情包、神梗段子、网友反应合集——我们把全网的瓜和网友的花式吐槽都帮你精选好了，点开就是快乐源泉。
          </p>

          <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <a
              href="#hot"
              className="btn-ripple rounded-full bg-primary-500 px-7 py-3 text-background-50 hover:bg-primary-600"
            >
              <i className="ri-heart-3-line"></i>
              看今日热评
            </a>
            <a
              href="#memes"
              className="btn-ripple rounded-full border border-background-300 bg-background-50 px-7 py-3 text-foreground-800 hover:bg-accent-100 hover:text-accent-800"
            >
              <i className="ri-emotion-laugh-line"></i>
              领表情包
            </a>
          </div>

          {/* 热搜词 */}
          <div className="mt-9 flex flex-wrap items-center justify-center gap-2">
            {hotTopics.slice(0, 4).map((t) => (
              <a
                key={t.id}
                href="#hot"
                className="flex items-center gap-1.5 whitespace-nowrap rounded-full bg-background-100 px-3.5 py-1.5 text-sm text-foreground-600 transition-colors hover:bg-primary-100 hover:text-primary-700"
              >
                <span className="text-primary-400">#</span>
                {t.title}
              </a>
            ))}
          </div>
        </div>
      </div>

      {/* 弹幕滚动区 */}
      <div className="container-page mt-12">
        <div className="relative overflow-hidden rounded-2xl bg-background-100 py-5">
          <div className="flex w-max animate-marquee gap-5 px-4">
            {[...barrageItems, ...barrageItems].map((b, i) => (
              <span
                key={`${b.id}-${i}`}
                className="whitespace-nowrap rounded-full bg-background-50 px-4 py-2 text-sm font-medium"
                style={{ color: b.color }}
              >
                <i className="ri-chat-smile-2-line mr-1.5"></i>
                {b.text}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}